import React from 'react';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error caught in ErrorBoundary:", error, errorInfo);
        // You could also log the error to an error reporting service here
    }

    resetError = () => {
        this.setState({ hasError: false });
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="flex flex-col items-center justify-center h-screen text-center space-y-4">
                    <h1 className="text-2xl font-bold">Something went wrong.</h1>
                    <p className="text-gray-600">An unexpected error has occurred. Please try again.</p>
                    <button 
                        onClick={this.resetError} 
                        className="btn btn-primary"
                    >
                        Try Again
                    </button>
                </div>
            );
        }

        return this.props.children; 
    }
}

export default ErrorBoundary;
